import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {AutoCompleteService} from "ionic2-auto-complete";
import {SocialService} from "./social-service";

/*
 Generated class for the TwitterUsers provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class TwitterUsers implements AutoCompleteService {
  labelAttribute = "screenName";

  constructor(public http: Http,
  private socialService: SocialService) {
    // console.log('Hello TwitterUsers Provider');
  }

  getResults(keyword: string) {
    return this.socialService.findUsers(keyword);
  }

}



// WEBPACK FOOTER //
// ./src/providers/twitter-users.ts